import { useUIColors } from '@/core/hooks';
import RefreshCwSvg from '@assets/images/svg/refresh-cw.svg';
import React from 'react';
import { View } from 'react-native';

export interface RefreshCwIconProps {
    size?: number;
    color?: string;
}

export const RefreshCwIcon = React.memo<RefreshCwIconProps>(function RefreshCwIcon({
    size = 20,
    color = '#333333',
}) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <RefreshCwSvg width={size} height={size} color={color} />
        </View>
    );
});

export default RefreshCwIcon;
